var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F90CC1FE-5A97-451A-A5BF-5F7EE73FEDDB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-652.000000, -3215.000000)",
    fill: "#545D61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(127.000000, 3160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons//edit",
    transform: "translate(525.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5019687,5.94684375 L18.0520938,4.49684375 C17.389625,3.834375 16.3118125,3.83440625 15.6493437,4.49684375 C15.025625,5.120625 5.498875,14.6480937 4.86221875,15.2847812 C4.79440625,15.3525937 4.74896875,15.4427187 4.73278125,15.530875 L4.00784375,19.445875 C3.97975,19.5976562 4.028125,19.7535625 4.13728125,19.8627187 C4.2465625,19.972 4.4025,20.0202812 4.55409375,19.9921875 L8.46875,19.2671562 C8.55921875,19.2502812 8.64815625,19.2044062 8.71484375,19.1376875 L19.5019687,8.34975 C20.1659688,7.68575 20.1660625,6.6109375 19.5019687,5.94684375 Z M5.05378125,18.946125 L5.4923125,16.577875 L7.421875,18.5075625 L5.05378125,18.946125 Z M8.38340625,18.1432813 L5.8565625,15.6162813 L15.081875,6.39025 L17.6087188,8.91728125 L8.38340625,18.1432813 Z M18.8390625,7.68684375 L18.2715938,8.254375 L15.74475,5.72734375 L16.3122187,5.1598125 C16.609125,4.862875 17.0922188,4.86284375 17.3891875,5.1598125 L18.8390625,6.6098125 C19.1367188,6.90746875 19.1367188,7.38915625 18.8390625,7.68684375 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1cc1cd35.svg";
export { ForwardRef as ReactComponent };